module.exports = __webpack_public_path__ + "img/flesh_golem_small.2b7293a4.png";